import axios from '@/config/axios'

/**
 * 通过父类列出
 * @param pid 父类ID
 * @returns {*}
 */
export const listServiceByPid = (pid) => axios.get(`/v1/api/mg/services?pid=${pid}`)

/**
 * 通过 ID查询服务详情
 * @param id 服务ID
 * @returns {*}
 */
export const serviceDetail = (id) => axios.get(`/v1/api/mg/services/${id}`)

/**
 * 通过 ID查询服务详情
 * @param  service 服务
 * @returns {*}
 */
export const createService = (service) => axios.post(`/v1/api/mg/services`, service)

/**
 * 通过 ID查询服务详情
 * @param  service 服务
 * @returns {*}
 */
export const updateService = (service) => axios.put(`/v1/api/mg/services/${service.id}`, service)

/**
 *  列出服务细节
 * @param serviceId 服务id
 * @returns {T | ActiveX.IXMLDOMNode | Promise<any> | V | string | IDBRequest | any | FormDataEntryValue | MediaKeyStatus}
 */
export const serviceOptions = (serviceId) => axios.get(`/v1/api/mg/services/${serviceId}/details`)

/**
 *  更新服务细节
 * @param serviceId 服务id
 * @param options
 * @returns {T | ActiveX.IXMLDOMNode | Promise<any> | V | string | IDBRequest | any | FormDataEntryValue | MediaKeyStatus}
 */
export const updateServiceOptions = (options, serviceId) => axios.post(`/v1/api/mg/services/${serviceId}/details`, options)


const orderBase = "/v1/api/mg/homeServiceOrder"

export const homeServiceOrder = (query) => axios.get(`${orderBase}`, {params: query})


export const homeServiceOrderSettle = (id) => axios.patch(`${orderBase}/${id}`)

export const homeServiceExport = (query) => axios.get(`${orderBase}?${query}`, {
    headers: {
        Accept: "application/vnd.ms-excel"
    },
    responseType: 'arraybuffer'
})


export const homeServiceOrderIv = (orderId) => axios.get(`${orderBase}/${orderId}/iv`, {responseType: 'arraybuffer'})


export const homeServiceOrderRc = (orderId) => axios.get(`${orderBase}/${orderId}/rc`, {responseType: 'arraybuffer'})

export const homeServiceReport = (orderId) => axios.get(`${orderBase}/${orderId}/rp`, {responseType: 'arraybuffer'})

export const homeServiceQuote = (orderId) => axios.get(`${orderBase}/${orderId}/qu`, {responseType: 'arraybuffer'})

